import { render, staticRenderFns } from "./header.vue?vue&type=template&id=5db0f458&"
import script from "./header.vue?vue&type=script&lang=ts&"
export * from "./header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db0f458')) {
      api.createRecord('5db0f458', component.options)
    } else {
      api.reload('5db0f458', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=5db0f458&", function () {
      api.rerender('5db0f458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/header/header.vue"
export default component.exports